import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mention-input-wrapper" }
const _hoisted_2 = ["onMousedown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "editor scrollable",
      ref: "editor",
      contenteditable: "",
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
      onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onKeydown && _ctx.onKeydown(...args))),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showSuggestions = false))
    }, null, 544),
    (_ctx.showSuggestions)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: "suggestions scrollable",
          style: _normalizeStyle(_ctx.suggestionPosition)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: user.id,
              class: _normalizeClass({ selected: index === _ctx.selectedIndex }),
              onMousedown: _withModifiers(($event: any) => (_ctx.selectUser(user)), ["prevent"]),
              ref_for: true,
              ref: "userItems"
            }, _toDisplayString(user.name), 43, _hoisted_2))
          }), 128))
        ], 4))
      : _createCommentVNode("", true)
  ]))
}